// @flow
// import RadioSelect from 'fg-frontend/src/components/RadioSelect';
// import Slider from 'fg-frontend/components/Slider';
// import NumberInput from 'fg-frontend/components/NumberInput';
// import SimpleCollapse from 'fg-frontend/components/SimpleCollapse';
// import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';
// import ListToggle from 'fg-frontend/components/ListToggle';
// import Typeahead from 'fg-frontend/components/Typeahead';
// import FulltextAutocomplete from 'fg-frontend/components/FulltextAutocomplete';
// import PasswordToggle from 'fg-frontend/components/PasswordToggle';
// import SocialShare from 'fg-frontend/components/SocialShare';
// import RangeDatepicker from 'fg-frontend/components/RangeDatepicker';
// import AnchorsList from 'fg-frontend/src/components/AnchorsList';
// import RadioSelectTab from 'fg-frontend/src/components/RadioSelectTab';
// import GreedyMenu from 'fg-frontend/components/GreedyMenu';
// import ShareUrl from 'fg-frontend/src/components/ShareUrl';
// import PrintPage from 'fg-frontend/src/components/PrintPage';
// import PrintPdf from 'fg-frontend/src/components/PrintPdf';
// import RedirectToUrl from 'fg-frontend/src/components/RedirectToUrl';
// import Form from 'fg-frontend/src/components/Form';
// import Webslider from 'fg-frontend/src/components/Webslider';
// import FileInput from 'fg-frontend/src/components/FileInput';
// import RangeSlider from 'fg-frontend/src/components/RangeSlider';

// import configureEshopComponents from './configureEshopComponents';
// import SelectDesign from './components/SelectDesign';
// import Tooltip from './components/Tooltip';
// import GtmHandler from './components/GtmHandler';
// import TriggerInViewport from './components/TriggerInViewport';
// import LazyImage from './components/LazyImage';
// import PhotoSwipe from './components/PhotoSwipe';
// import Countdown from './components/Countdown';
// import Toggler from './components/Toggler';
// import FGUpload from './components/FGUpload';
// import ShowMorePhotos from './components/ShowMorePhotos';
import AddSvgIconSprite from './components/AddSvgIconSprite';
import LandingHeader from './components/LandingHeader';
import Parallax from './components/Parallax';
import DeviceMove from './components/DeviceMove';
import LandingShowcase from './components/LandingShowcase';
import Gallery from './components/Gallery';
import AnimateInViewport from './components/AnimateInViewport';
import PopupForm from './components/PopupForm';
import AnchorSlider from './components/AnchorSlider';
import ARChoose from './components/ARChoose';
import ARChoose2 from './components/ARChoose2';


export default (props) => {
  switch (props.decorator || props.is) {
    case 'AddSvgIconSprite':
      return AddSvgIconSprite;
    case 'LandingHeader':
      return LandingHeader;
    case 'AnimateInViewport':
      return AnimateInViewport;
    case 'Parallax':
      return Parallax;
    case 'DeviceMove':
      return DeviceMove;
    case 'LandingShowcase':
      return LandingShowcase;
    case 'Gallery':
      return Gallery;
    case 'PopupForm':
      return PopupForm;
    case 'AnchorSlider':
      return AnchorSlider;
    case 'ARChoose':
      return ARChoose;
    case 'ARChoose2':
      return ARChoose2;
    case 'GoogleRecaptcha':
      return import('fg-frontend/src/components/GoogleRecaptcha');
    default:
      const eshopComponent = configureEshopComponents(props);
      if (eshopComponent) {
        return eshopComponent;
      }
      console.log(`Unknown component ${props.decorator || props.is}`);
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js